import { FormProvider } from 'react-hook-form';
import { ControlledTextField } from '..';

export default function InlineRejectionForm({
  methods,
  disabled,
  label = 'Rejection Reason',
  placeholder = 'Enter rejection reason',
  onCancel,
  onSubmit,
  minLength = 3,
  maxLength = 300,
}) {
  return (
    <FormProvider {...methods}>
      <form className='column gap-4'>
        <div className='row gap-3'>
          <ControlledTextField
            name='rejectionReason'
            id='rejectionReason'
            label={label}
            placeholder={placeholder}
            disabled={disabled}
            rules={{
              required: 'Rejection reason is required',
              minLength: {
                value: minLength,
                message: `Minimum ${minLength} characters required`,
              },
              maxLength: {
                value: maxLength,
                message: `Maximum ${maxLength} characters allowed`,
              },
            }}
            orientation='row'
            showErrorInline
            reserveErrorSpace
            fullWidth
          />

          <div className='row gap-3 self-start'>
            <button
              type='button'
              className='btn text-btn underline'
              onClick={onCancel}
              disabled={disabled}
            >
              Cancel
            </button>

            <button
              type='button'
              className='btn cta-outlined-btn'
              onClick={onSubmit}
              disabled={disabled}
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}
